import { lowerCase, startCase } from 'lodash-es';

export function titleCase(value: string|number|Date): string {
    return startCase(lowerCase(value.toLocaleString()));
}